import i18n from 'i18n';
import {
    useState,
    useEffect,
    useCallback,
  } from 'react';
  import { useSelector } from 'react-redux';
  
  const useDataFetching = (url, now=true) => {
    
    const { token } = useSelector((state) => state.auth);
    console.log("token ", token)
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [error, setError] = useState(false);
  
    const fetchData = useCallback(async () => {
    if(url){  try {
        setLoading(true);
        const headers = {
          'Accept-Language': i18n.language,
        };
        if (token) {
          headers['Authorization'] = `Bearer ${token}`;
        }
        const data = await fetch(url, {
          method: 'GET',
          headers,
        });
        const result = await data.json();
        if (result) {
          setData(result);
          setLoading(false);
        }
      } catch (e) {
        setData([])
        setError(e.message);
        console.log("error ", e)
        setLoading(false);
      }}
    }, [url]);
  
    useEffect(() => {
      now && fetchData();
      // TODO: delete cash
    }, [url]);
  
    return [loading, error, data, fetchData];
  };
  
  export default useDataFetching;